import { transparentColors } from '@assets/styles/helpers/colors.styles'
import { floatingSurface } from '@/shared/styles/floatingSurface.styles'

/**
 * The button, sized by its label. Fine in a row of two or three colours, which
 * is every caller but one.
 */
export const colorPickerButtonStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1rem',
  padding: '0.5rem 0.75rem',
  borderRadius: '0.5rem',
  backgroundColor: transparentColors.whiteShade2,
  outline: 'none',
  '&:hover': {
    backgroundColor: transparentColors.whiteShade3
  },
  '&:active': {
    outline: 'none'
  },
  '&:focus': {
    outline: 'none'
  },
  '&:focus-within': {
    outline: 'none'
  }
}

export const tooltipStyles = {
  '&.MuiTooltip-tooltip': {
    ...floatingSurface,
    margin: '0.25rem 0 0 0 !important',
    padding: '0.75rem 0.75rem 1rem 0.75rem !important'
  }
}

export const popperStyles = {
  marginTop: '0.5rem !important',
  padding: '0.5rem'
}

/**
 * The same button, filling its column.
 *
 * For a list of colours read top to bottom, where content-width buttons make a
 * ragged edge and a long name wraps and doubles that one button's height. The
 * name goes to the left, the swatch to the right, and every row lines up.
 */
export const colorPickerFullWidthStyles = {
  ...colorPickerButtonStyles,
  width: '100%',
  justifyContent: 'space-between',
  textAlign: 'left',
  // Half the gap of the content-width button: here the space between the name
  // and the swatch is whatever is left over, so it needs no help.
  gap: '0.5rem'
}
